import { db } from '$db/local/db';
import { getActiveUserId } from '$core/identity/active-user';

export async function importFromFile(file: File): Promise<void> {
  const text = await file.text();
  const bundle = JSON.parse(text);
  const currentUserId = getActiveUserId();

  if (!bundle.version || bundle.version !== 5) {
    throw new Error('Invalid or unsupported bundle version.');
  }

  // Helper para reasignar el userId actual y asegurar camelCase
  const processItem = (item: any) => {
    return { 
      ...item, 
      userId: currentUserId,
      // Convertir snake_case a camelCase si es necesario
      parentId: item.parent_id !== undefined ? item.parent_id : item.parentId,
      createdAt: item.created_at !== undefined ? item.created_at : item.createdAt,
      updatedAt: item.updated_at !== undefined ? item.updated_at : item.updatedAt,
      deletedAt: item.deleted_at !== undefined ? item.deleted_at : item.deletedAt,
      nodeId: item.node_id !== undefined ? item.node_id : item.nodeId,
      macroSessionId: item.macro_session_id !== undefined ? item.macro_session_id : item.macroSessionId,
    };
  };

  await db.transaction('rw', [
    db.nodes, db.nodeTemplates, db.macroSessions, db.problemAttempts,
    db.recallItems, db.reviewEvents, db.memoryWeights, db.conjectures,
    db.sleepRecords, db.studyGoals
  ], async () => {
    // Limpiamos los datos actuales del usuario
    await db.nodes.where('userId').equals(currentUserId).delete();
    await db.nodeTemplates.where('userId').equals(currentUserId).delete();
    await db.macroSessions.where('userId').equals(currentUserId).delete();
    await db.problemAttempts.where('userId').equals(currentUserId).delete();
    await db.recallItems.where('userId').equals(currentUserId).delete();
    await db.reviewEvents.where('userId').equals(currentUserId).delete();
    await db.memoryWeights.where('userId').equals(currentUserId).delete();
    await db.conjectures.where('userId').equals(currentUserId).delete();
    await db.sleepRecords.where('userId').equals(currentUserId).delete();
    await db.studyGoals.where('userId').equals(currentUserId).delete();

    // Insertamos los nuevos datos usando bulkPut (evita errores de duplicados)
    if (bundle.nodes?.length) await db.nodes.bulkPut(bundle.nodes.map(processItem));
    if (bundle.nodeTemplates?.length) await db.nodeTemplates.bulkPut(bundle.nodeTemplates.map(processItem));
    if (bundle.macroSessions?.length) await db.macroSessions.bulkPut(bundle.macroSessions.map(processItem));
    if (bundle.problemAttempts?.length) await db.problemAttempts.bulkPut(bundle.problemAttempts.map(processItem));
    if (bundle.recallItems?.length) await db.recallItems.bulkPut(bundle.recallItems.map(processItem));
    if (bundle.reviewEvents?.length) await db.reviewEvents.bulkPut(bundle.reviewEvents.map(processItem));
    if (bundle.memoryWeights?.length) await db.memoryWeights.bulkPut(bundle.memoryWeights.map(processItem));
    if (bundle.conjectures?.length) await db.conjectures.bulkPut(bundle.conjectures.map(processItem));
    if (bundle.sleepRecords?.length) await db.sleepRecords.bulkPut(bundle.sleepRecords.map(processItem));
    if (bundle.studyGoals?.length) await db.studyGoals.bulkPut(bundle.studyGoals.map(processItem));
  });
}